import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

export const getUserIntegrationList = async (redirect_url) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/integration',
    params: {
      redirect_url
    }
  })

  return response?.data
}